import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'br', 'p', 'a'];
const ALLOWED_URI_REGEXP = /^https?:\/\//i;

/* eslint-disable @typescript-eslint/naming-convention */
const purifyConfig = {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href'],
    ALLOWED_URI_REGEXP,
    ALLOW_ARIA_ATTR: false,
    ALLOW_DATA_ATTR: false,
};
/* eslint-enable @typescript-eslint/naming-convention */

DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export const sanitizeBannerHtml = (html: string): string =>
    html ? DOMPurify.sanitize(html, purifyConfig) : '';
